module.exports = __webpack_public_path__ + "static/img/monitiornew4.2a4cffe1.webp";